<div class="row">
  @if (label) {
<div [ngClass]="{'col-md-4': !bigInput && !modal, 'col-md-2': bigInput && !modal,
                    'col-modal-4': !bigInput && modal, 'col-modal-2': bigInput && modal}">
      <label>@if (mandatory) {
        <span style="color: red">*</span>
      }{{label + endingCharacter()}}</label>
    </div>
  }
  <div [ngClass]="{ 'col-md-12': !label,
                    'col-md-8': label && (!bigInput && !modal),
                    'col-md-10': label && (bigInput && !modal),
                    'col-modal-8': label && (!bigInput && modal),
                    'col-modal-10': label && (bigInput && modal)}">
    @if (((fieldLevelSecurity === 'U' || fieldLevelSecurity === 'A') && editable) || (fieldLevelSecurity === undefined && editable)) {
      <mat-form-field class="selectInput"
                    [ngClass]="{'inputErrorBackground': validatorMessages.length > 0,
                     'redArrow': !hideRequiredMarker,
                     'blackArrow': hideRequiredMarker,
                     'tableInput': tableInput}"
        [hideRequiredMarker]="hideRequiredMarker">
        <mat-select [(value)]="selected" (selectionChange)="onSelect($event.value)" [compareWith]="compareFn"
          [required]="mandatory" (blur)=" tooltip.hide()" [matTooltip]="toolTips" (focus)="tooltip.show()"
          #tooltip="matTooltip" (keyup)="findOption($event)" (opened)="scrollToOption()" [id]="id">
          @if (virtualScroll) {
            <cdk-virtual-scroll-viewport [itemSize]="15" [style.height.px]=getHeight() >
              <!--          <mat-option [value]="null" *ngIf="nullValue"></mat-option>-->
              <mat-option *cdkVirtualFor="let option of options" [value]="option[0]">
                {{showOption(option)}}
              </mat-option>
              @if (selected) {
                <mat-option [value]="selected">{{displayValue}}</mat-option>
              }
            </cdk-virtual-scroll-viewport>
          }
          @if (!virtualScroll) {
            <!--          <mat-option [value]="null" *ngIf="nullValue"></mat-option>-->
            @for (option of options; track option) {
              <mat-option [value]="option[0]">
                {{showOption(option)}}
              </mat-option>
            }
          }
        </mat-select>
      </mat-form-field>
    }
    @if ((!editable && (fieldLevelSecurity === 'U' || fieldLevelSecurity === 'A')) ||
      (fieldLevelSecurity === undefined && !editable) || fieldLevelSecurity === 'I') {
      <mat-form-field
        [ngClass]="{'tableInput': tableInput}"
        class="textInput">
        <input matInput [(ngModel)]="displayValue" [required]="mandatory" [disabled]="true"
          (blur)="offFocus(); tooltip.hide()" [matTooltip]="toolTips" (focus)="tooltip.show()" #tooltip="matTooltip">
        </mat-form-field>
      }
      @if (fieldLevelSecurity === 'N') {
        <mat-form-field class="textInput" [ngClass]="{'tableInput': tableInput}">
          <input matInput [disabled]="true">
        </mat-form-field>
      }
      @for (message of validatorMessages; track message) {
        <div class="inputValidationMessage" [ngClass]="{'inputValidationMessageTable' : tableInput}">
          {{message}}
        </div>
      }
    </div>
  </div>
